import React, { useState } from 'react';
import Button from '../../../components/UI/Button/Button';
import './userColibrate.css';
import Modal from '../../../modal/modal';
import ModalContent from '../../../modal/ModalContent';
import ModalAddWifiDot from '../../../components/modalContent/addWifiDot/addWifiDot';
import ModalDeleteWifiDot from '../../../components/modalContent/deleteWifiDot/deleteWifiDot';
import ModalChangeWifiDots from '../../../components/modalContent/changeWifiDots/changeWifiDots';

const UserColibrate = ({ data, fullData, selectedBuildingId, selectedFloorId }) => {
  const [userId, setUserId] = useState('');
  const [coordinatesX, setCoordinatesX] = useState('');
  const [coordinatesY, setCoordinatesY] = useState('');
  const [bssids, setBssids] = useState([]);
  const [bssidsFull, setBssidsFull] = useState([]);
  const [isModalActive, setIsModalActive] = useState(false);
  const [isModalDeleteActive, setIsModalDeleteActive] = useState(false);
  const [isModalChangeDots, setIsModalChangeDots] = useState(false);

  const handleWifiSettingsClick = () => {
    if (data.length === 0) return alert('Выберите точки для изменения');
    setIsModalChangeDots(true);
  };

  const handleUserIdChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setUserId(value);
  };

  const handleCoordinatesChangeX = (e) => {
    const value = e.target.value.replace(/[^0-9.-]+/g, '');
    setCoordinatesX(value);
  };

  const handleCoordinatesChangeY = (e) => {
    const value = e.target.value.replace(/[^0-9.-]+/g, '');
    setCoordinatesY(e.target.value);
  };
  const handleDeleteComplete = () => {
    window.location.reload();
  };

  const bssidsFULL = () => {
    let fullBssids = [];
    for (let i = 0; i < fullData.length; i++) {
      fullBssids.push(fullData[i].bssid);
    }
    setBssidsFull(fullBssids);
  };

  const addWifiDot = () => {
    setIsModalActive(true);
  };
  const deleteWifiDot = () => {
    setIsModalDeleteActive(true);
  };

  // Populate bssids array from data
  React.useEffect(() => {
    const bssidsArray = data.map((item) => item.bssid);
    setBssids(bssidsArray);
  }, [data]);

  // Populate bssidsFull array from fullData
  React.useEffect(() => {
    const bssidsFullArray = fullData.flatMap((item) => item.bssids);
    setBssidsFull(bssidsFullArray);
    bssidsFULL();
  }, [fullData]);

  const isDeleteWifiDot = bssids.length === 0;

  return (
    <div className="UserColibrate">
      {/* <div className="userColibrateDiv">
        <input
          className="userColibrateInput"
          type="text"
          placeholder="ID пользователя"
          value={userId}
          onChange={handleUserIdChange}
        ></input>
        <input
          className="userColibrateInput"
          type="text"
          placeholder="Координаты x"
          value={coordinatesX}
          onChange={handleCoordinatesChangeX}
        ></input>
        <input
          className="userColibrateInput"
          type="text"
          placeholder="Координаты y"
          value={coordinatesY}
          onChange={handleCoordinatesChangeY}
        ></input>
      </div> */}
      <div>
        <Button className={`UserColibrateButton`} onClick={addWifiDot} text="Добавить Wifi точку" />
        <Modal active={isModalActive} setActive={setIsModalActive} width={'400px'} height={'600px'}>
          <ModalContent>
            <ModalAddWifiDot
              setIsModalActive={setIsModalActive}
              building_id={selectedBuildingId}
              floor_id={selectedFloorId}
            />
          </ModalContent>
        </Modal>
        <Button
          className={`UserColibrateButton ${isDeleteWifiDot ? 'disabled' : ''}`}
          onClick={deleteWifiDot}
          text="Удалить Wifi точку"
          disabled={isDeleteWifiDot}
        />
        <Modal
          active={isModalDeleteActive}
          setActive={setIsModalDeleteActive}
          width={'400px'}
          height={'600px'}
        >
          <ModalContent>
            <ModalDeleteWifiDot
              setIsModalActive={setIsModalDeleteActive}
              onDelete={handleDeleteComplete}
              bssids={bssids}
            />
          </ModalContent>
        </Modal>
        <Button
          className={`UserColibrateButton ${!data.length ? 'disabled' : ''}`}
          text={`Изменить WiFi точки `}
          onClick={handleWifiSettingsClick}
          disabled={!data.length}
        ></Button>
        <Modal active={isModalChangeDots} setActive={setIsModalChangeDots} width={'400px'} height={'600px'}>
          <ModalContent>
            <ModalChangeWifiDots
              setIsModalActive={setIsModalChangeDots}
              onChange={() => alert('Точки успешно обновлены')}
              selectedBuildingId={selectedBuildingId}
              data={data}
            />
          </ModalContent>
        </Modal>
      </div>
    </div>
  );
};

export default UserColibrate;
